import jsonLd from './functions/_jsonLd'
import salonPage from './functions/salonPage'

export default function JsonLdSalon ({ firm, map, offers }) {
    return jsonLd(salonPage({ firm, map, offers }))
}
